module.exports = __webpack_public_path__ + "img/album13_02.8ff27504.jpg";